import { idGenerator } from '@/services'

export interface ChargingStationDeclarationState {
  requestId: string
}

export const InitialState: ChargingStationDeclarationState = {
  requestId: idGenerator.getNewWebReference()
}
